const cache = new Map();

export default class InlineSvg extends HTMLElement {
  connectedCallback() {
    if (this._handled) return;
    this._handled = true;
    this.load();
  }

  async load() {
    const src = this.getAttribute("src");
    if (!src) return;

    try {
      let text = cache.get(src);
      if (!text) {
        const res = await fetch(src);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        text = await res.text();
        cache.set(src, text);
      }

      const cleaned = text
        .replace(/<\?xml[^>]*\?>/g, "")
        .replace(/<!DOCTYPE[^>]*>/gi, "")
        .trim();

      const doc = new DOMParser().parseFromString(cleaned, "image/svg+xml");
      const svg = doc.documentElement;

      if (svg.tagName.toLowerCase() !== "svg" || svg.querySelector("parsererror")) {
        throw new Error("Invalid SVG response");
      }

      svg.setAttribute("preserveAspectRatio", "xMidYMid meet");
      svg.removeAttribute("width");
      svg.removeAttribute("height");

      const classList = this.getAttribute("class");
      if (classList) svg.setAttribute("class", classList);

      const adopted = document.importNode(svg, true);
      if (this.parentNode) {
        const parent = this.parentNode;
        parent.replaceChild(adopted, this);

        // If the parent opted in via inline --ar, correct it using the SVG's
        // real content bounds — Shopify's image.aspect_ratio reads the file's
        // viewBox, which may include padding around the artwork.
        if (parent instanceof HTMLElement && parent.style.getPropertyValue("--ar")) {
          requestAnimationFrame(() => {
            try {
              const bbox = adopted.getBBox();
              if (bbox.width > 0 && bbox.height > 0) {
                parent.style.setProperty("--ar", bbox.width / bbox.height);
              }
            } catch (e) { /* getBBox throws if not rendered */ }
          });
        }
      }
    } catch (err) {
      console.warn("InlineSvg failed:", src, err);
      this._handled = false;
    }
  }
}
